import MediaPanel from "@/components/MediaPanel";
import MobPlusIndicator from "@/components/MobPlusIndicator";
import clsx from "clsx";
import React from "react";

const MediaPanelWrapper = ({
  contentIsRestricted,
  isMobPlusMember,
  entry,
  first,
}) => {
  const image = entry.image?.[0];

  return (
    <div
      className={clsx(
        "RecipeHero__media",
        "relative h-full w-full print:!container print:mx-auto"
      )}
    >
      {contentIsRestricted && (
        <div
          className={clsx(
            "absolute left-6 top-6 z-30 block lg:hidden print:hidden"
          )}
        >
          <MobPlusIndicator locked={!isMobPlusMember} />
        </div>
      )}

      <MediaPanel
        image={image}
        brightcoveVideoId={entry.brightcoveVideoId}
        priority={first}
        showCTAOverlay={contentIsRestricted && !isMobPlusMember}
      />
    </div>
  );
};

export default MediaPanelWrapper;
